import { Redirect, Switch } from 'react-router-dom';
import { getJSON } from 'bv-fetch';
import { useFetch } from 'bv-hooks';
import { ModalWindow, Spinner } from 'bv-components';

import { Route } from '../../shared';

import {
  TwoFACode,
  TwoFADeviceManager,
  TwoFAEnable,
  TwoFARegisterPhone,
  TwoFATotpScan,
  TwoFATotp,
} from '../lazy_components';

const TwoFaPreferencesRoutes = () => {
  // This component is rendered only if the route is /preferences/twofactorauth
  // Do the validations for all these routes and redirect if not valid
  // In conversations with Goncalo to move this component to a 2FA bundle
  // We have 1 bundle per component at this moment, 2FA is not that big
  // Think about 1 bundle for all 2FA
  const [data, loading] = useFetch(() => (
    getJSON('/bv_api/twofactorauth/check_user_authenticated')
  ));

  if (loading) return <ModalWindow><Spinner /></ModalWindow>;
  if (!data.success) return <Redirect to="/preferences/verify_password_twofactor" />;

  return (
    <Switch>
      <Route path="/preferences/twofactorauth/code">
        <TwoFACode />
      </Route>
      <Route path="/preferences/twofactorauth/devicemanager">
        <TwoFADeviceManager />
      </Route>
      <Route path="/preferences/twofactorauth/enable">
        <TwoFAEnable />
      </Route>
      <Route path="/preferences/twofactorauth/sms">
        <TwoFARegisterPhone />
      </Route>
      <Route path="/preferences/twofactorauth/totp/scan">
        <TwoFATotpScan />
      </Route>
      <Route path="/preferences/twofactorauth/totp">
        <TwoFATotp />
      </Route>
    </Switch>
  );
};

export default TwoFaPreferencesRoutes;
